'use client';

import { useTranslation } from 'src/i18n/client';
import AppointmentsForm from './AppointmentsForm';
import { RecaptchaContextProvider } from 'src/hooks/useRecaptcha';
import TestSelection from './TestSelection';

type Props = {
    locale: string;
    config: any;
    location?: any;
    noTestsBanner: boolean;
};

export default function AppointmentsView({ locale, config, location, noTestsBanner }: Props) {
    const { t } = useTranslation(locale, 'common');

    return (
        <section className="relative">
            <div className="bg-lightest-grey absolute bottom-0 left-0 right-[50%] top-0 -z-10" />
            <div className="bg-lightest-grey absolute bottom-0 left-[50%] right-0 top-0 -z-10 hidden lg:block lg:bg-white" />
            <div className="container mx-auto flex-row lg:flex">
                <div className="bg-lightest-grey lg:w-2/3">
                    <RecaptchaContextProvider action="appointment" keyId={config.recaptchaKeyId} bottom={80}>
                        <AppointmentsForm locale={locale} location={location} noTestsBanner={noTestsBanner} />
                    </RecaptchaContextProvider>
                </div>
                <div className="hidden flex-1 bg-white px-6 py-10 lg:block">
                    <div className="top-nav-md-height sticky pt-4">
                        <TestSelection renderFor="desktop" noTestsBanner={noTestsBanner} />
                    </div>
                </div>
            </div>
        </section>
    );
}
